export const COL_FILTER = {
  styleMaxWidth: 'max-width: 324px;',
  style: 'min-width: 324px; max-width: 324px;',
  class: 'd-flex align-center',
};

export const BTN_FILTER = {
  style: 'height: 50px; width: 200px; border-radius: 10px;',
};